import axios from 'axios';
import { UIUtilsEjsVariables } from '../../../../shared/scripts/UIUtilsEjsVariables.ts';
export class ShareImageHelper {
    static async uploadImageToDiscordCDN(messageData, accessToken) {
        if (messageData.data == undefined) throw new Error('Must include imageFile in data');
        const imageFile = messageData.data['imageFile'];
        /* eslint-disable-next-line @typescript-eslint/naming-convention */ const headers = {
            Authorization: `Bearer ${accessToken}`
        };
        const uploadImageEndpoint = `https://discord.com/api/v10/activities/${UIUtilsEjsVariables.discordSDKClientId}/attachment`;
        const formData = new FormData();
        formData.append('file', imageFile);
        const response = await axios.post(uploadImageEndpoint, formData, {
            headers: headers
        });
        return response.data.attachment.url;
    }
}
